import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Linking,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { trackMoengageEvent } from "../../../utils/commonMethods";

const SettlementLink = ({ source }) => {
  const linkRedirection = () => {
    trackMoengageEvent("Source Of Settlement");
    if (source) {
      try {
        Linking.openURL(source);
        Linking.canOpenURL(source).then((supported) => {
          if (supported) {
            Linking.openURL(source);
          } else {
            console.log("Don't know how to open URI: " + source);
          }
        });
      } catch (e) {}
    }
  };

  return source ? (
    <View style={styles.settlementTimelineContainer}>
      <Text
        style={{
          ...globalFontStyle.appFontSmallText,
          color: Colors.lightgrey,
        }}
      >
        Settlement Link:
      </Text>
      <TouchableOpacity onPress={linkRedirection} activeOpacity={0.8}>
        <Text
          style={[
            globalFontStyle.appFontSmallText,
            { color: Color.tradexBlue, paddingLeft: 3 },
          ]}
        >
          {source && source.split("/").slice(0, 3).join("/")}
        </Text>
      </TouchableOpacity>
    </View>
  ) : null;
};

export default SettlementLink;

const styles = StyleSheet.create({
  settlementTimelineContainer: {
    flexDirection: "row",
    backgroundColor: Color.lightgrey1,
    paddingHorizontal: 10,
    flex: 1,
    borderRadius: 50,
    paddingVertical: 8,
    marginTop: 15,
  },
});
